var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFipe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 12.5v-2.2a1.5 1.5 0 0 1 1.2-1.47l1.5-.3 1.9-3.1a1.8 1.8 0 0 1 1.54-.88h4.72a1.8 1.8 0 0 1 1.54.88l1.9 3.1 1.5.3a1.5 1.5 0 0 1 1.2 1.47v2.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2 8.53h11.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 12.5h2.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12.5h5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3 12.5h2.2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.6,
    cy: 12.5,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.4,
    cy: 12.5,
    r: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 18h16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 21h9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFipe);
export default __webpack_public_path__ + "static/media/fipe.19bf13736b4cabcc8c04b76fefac31d3.svg";
export { ForwardRef as ReactComponent };